/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



//// Summary
//// Code for Triumph Stock retreival - Used by Mini cart ////
//// The warehouse shopify template has more strict AJAX rendering for the mini cart. This leads to issues such as it attempts to re-render the cart which removes our updated DOM value
//// Which we use for displaying stock availability. Current workaround uses Event listener as demostrated above and recheck availability once cart has been updated; this doesnt use an 
//// extra API call as the data is saved to local cache

// Global cache for availability data across page reloads
window.triumphCache = window.triumphCache || {};

// Debounce function to prevent rapid multiple calls to the same function
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

// Updates availability information after cart changes
const refreshAllAvailability = debounce(() => {
  updateTriumphAvailability();
}, 800);

// Main function that finds elements and updates availability data
window.updateTriumphAvailability = function(root = document) {
  const hooks = [];//Stores the elements with the data-triumph-hook attribute
  if (root.matches && root.matches('[data-triumph-hook]')) hooks.push(root);
  hooks.push(...root.querySelectorAll('[data-triumph-hook]'));

  hooks.forEach(el => {
    const productSku = el.dataset.triumphSku || el.dataset.itemSku || el.closest('[data-item-sku]')?.dataset.itemSku;
    if (!productSku) return;

    if (window.triumphCache[productSku]) {
      updateElementWithAvailability(el, window.triumphCache[productSku]);
      return;
    }

    // Updates element to avoid multiple calls
    if (window.triumphCache[productSku + '_fetching']) return;
    window.triumphCache[productSku + '_fetching'] = true;

    fetch('https://triumph-api-609529236666.europe-west2.run.app/api/product-availability', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productSku })
    })
    .then(r => r.json())
    .then(data => {
      if (data.success && data.availability && data.availability.availability) {
        window.triumphCache[productSku] = data.availability.availability;
        
        document.querySelectorAll(`[data-triumph-hook][data-item-sku="${productSku}"], 
                                 [data-item-sku="${productSku}"] [data-triumph-hook]`).forEach(element => {
          updateElementWithAvailability(element, data.availability.availability);
        });
      }
      delete window.triumphCache[productSku + '_fetching'];
    })
    .catch(() => {
      window.triumphCache[productSku] = 'Availability unknown';
      delete window.triumphCache[productSku + '_fetching'];
    });
  });
};

// Updates DOM elements with availability information
function updateElementWithAvailability(element, availability) {
  let displayText = availability;
  let statusClass = '';
  const isMiniCart = !!element.closest('.mini-cart, .mini-cart__item-wrapper');
  
  // Apply different text and styling based on availability value
  if (availability === 'Available') {
    statusClass = 'triumph-available';
  } 
  else if (availability === 'Out of stock') {
    displayText = isMiniCart ? `Available to Order` : `Available to Order – We'll dispatch as soon as the factory has it`;
    statusClass = 'triumph-outofstock';
  }
  else if (availability === 'Obsolete') {
    statusClass = 'triumph-obsolete';
  }
  
  element.innerHTML = `<span class="triumph-status ${statusClass}">${displayText}</span>`;
  element.dataset.triumphAvailability = availability;
}

/// Below until EO Triumph code is for listerners throughout the page to ensure stock is populated
/// As the theme is modified in different ways, AJAX + traditional DOM, we need several listerners to ensure product elements are handled correctly

// Tracks the last cart update to handle race conditions
window.lastCartUpdateTime = 0;

// Initialize on document ready
document.addEventListener('DOMContentLoaded', () => {
  // Handle race condition when arriving at cart page
  if (window.location.pathname.includes('/cart')) {
    const now = Date.now();
    const timeSinceLastUpdate = now - window.lastCartUpdateTime;
    
    if (timeSinceLastUpdate < 3000) {
      setTimeout(updateTriumphAvailability, 1000);
    } else {
      updateTriumphAvailability();
    }
  } else {
    updateTriumphAvailability();
  }
  
  // Intercept all fetch calls to detect cart operations
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    const result = originalFetch.apply(this, arguments);
    
    if (typeof url === 'string' && 
        (url.includes('/cart/change') || 
         url.includes('/cart/update') || 
         url.includes('/cart/add') ||
         url.includes('/cart/clear'))) {
      window.lastCartUpdateTime = Date.now();
      result.then(() => refreshAllAvailability());
    }
    
    return result;
  };
  
  // Listen for Warehouse theme quantity button clicks
  document.addEventListener('click', function(e) {
    const target = e.target.closest('[data-action="increase-quantity"], [data-action="decrease-quantity"]');
    if (target) {
      window.lastCartUpdateTime = Date.now();
    }
  });
  
  // Listen for standard Shopify cart events
  document.addEventListener('cart:refresh', refreshAllAvailability);
  document.addEventListener('cart:updated', refreshAllAvailability);
  document.addEventListener('product:added', function() {
    window.lastCartUpdateTime = Date.now();
    refreshAllAvailability();
  });
  
  // Watch cart container for significant DOM changes
  const cartContainer = document.querySelector('.cart__items, .cart-items, .line-items');
  if (cartContainer) {
    const cartObserver = new MutationObserver((mutations) => {
      let significantChange = false;
      
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && 
            (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
          significantChange = true;
          break;
        }
      }
      
      if (significantChange) {
        refreshAllAvailability();
      }
    });
    
    cartObserver.observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }
});
// Triumph Stock Finish